export function PatientNotifications({
  notifications = {},
  onClickMenuOption,
  patientId,
  patientCode,
}) {
  const alerts = [
    { key: "encargo", label: "Encargo", active: notifications.encargo },
    { key: "deuda", label: "Deuda", active: notifications.deuda },
    { key: "cita", label: "Cita", active: notifications.cita },
  ];

  const hasNotifications = alerts.some((a) => a.active);

  return (
    <div className="patient-info-3" style={{ width: 75 }}>
      <div className="alert-container">
        <img
          style={{ width: 22 }}
          src={
            hasNotifications
              ? "/images/alert-on-orange.svg"
              : "/images/alert-off-blue.svg"
          }
          loading="lazy"
          alt="Icon"
        />
        <span>Avisos</span>
      </div>
      <div className="alert-list">
        {alerts
          .filter((a) => a.active)
          .map((a) => (
            <div key={a.key} className="alert">
              <div className="pointer"></div>
              <span>{a.label}</span>
              <button
                onClick={() => {
                  switch (a.key) {
                    case "cita":
                      onClickMenuOption("agenda", "");
                      break;
                    case "deuda":
                      onClickMenuOption("ventas", {
                        debtor: { code: patientCode, id: patientId },
                      });
                      break;
                    case "encargo":
                      onClickMenuOption("ventas", {
                        orderer: { code: patientCode, id: patientId },
                      });
                      break;
                  }
                }}
              >
                <img
                  src="/images/alert-link.svg"
                  loading="lazy"
                  alt="Icon"
                  className="alert-container-icon"
                />
              </button>
            </div>
          ))}
      </div>
    </div>
  );
}
